import { getAPICall, postAPICall, defaultCallback } from './BaseAPI';

export const getStoreDetailDB = async (payload:any, callback=defaultCallback) => {
  return await postAPICall({ route: 'settings/getstoredetailbyurl', payload, callback });
}

export const searchAddress = async (str:any, storeId:number, callback=defaultCallback) => {
  const encodedStr = encodeURIComponent(str);
  return await getAPICall({ route: 'address/search/'+encodedStr+'/'+storeId, callback });
}

// USPS Address Lock-in: live typeahead of verified US addresses (Mapbox-backed,
// proxied server-side). Used when a brand has require_usps_address enabled.
// Pass optional comma-separated zip codes to restrict results.
export const searchUspsAddress = async (str:any, callback=defaultCallback, zips?: string) => {
  const encodedStr = encodeURIComponent(str);
  let route = 'address/usps-suggest?q='+encodedStr;
  if (zips) route += '&zips=' + encodeURIComponent(zips);
  return await getAPICall({ route, callback });
}

// Resolves a picked USPS suggestion's mapbox_id into full details (incl. lat/lng).
// Pass the same session_token used for the preceding searchUspsAddress call.
export const retrieveUspsAddress = async (mapboxId: string, sessionToken?: string, callback=defaultCallback) => {
  let route = 'address/usps-retrieve?id=' + encodeURIComponent(mapboxId);
  if (sessionToken) route += '&session_token=' + encodeURIComponent(sessionToken);
  return await getAPICall({ route, callback });
}

export const getDocumentsData = async (documentId:number, callback=defaultCallback) => {
  return await getAPICall({ route: 'settings/getdocumentbyid/'+documentId, callback });
}

export const getPlantationsData = async (belongs_to?: string, callback=defaultCallback) => {
  let route = 'alladdresses/getplantationsdata/';
  if (belongs_to) {
    route += `?belongs_to=${belongs_to}`;
  }
  return await getAPICall({ route, callback });
}